import AdobeLaunch from "@/plugins/adobe-launch";

describe("Inyección AdobeLaunch", () => {
  test("debería inyectar AdobeLaunch productivo para el dominio de producción", () => {
    delete window.location;
    window.location = { hostname: "www.bbva.com.ar" };

    const Vue = {
      $log: {
        info: jest.fn()
      }
    };

    AdobeLaunch.install(Vue);

    const scriptElement = document.head.querySelector(
      'script[src="//assets.adobedtm.com/95c3e405673d/81c80ecf6aaf/launch-144c155dcd64.min.js"]'
    );
    expect(scriptElement).toBeTruthy();

    expect(scriptElement.async).toBe(true);
    expect(scriptElement.defer).toBe(true);

    expect(Vue.$log.info).toHaveBeenCalledWith(
      "AdobeLaunch inyectada",
      "Produccion"
    );
  });

  test("debería inyectar adobbe launch development para ambiente test", () => {
    delete window.location;
    window.location = { hostname: "app-work.bbva.com.ar" };

    const Vue = {
      $log: {
        info: jest.fn()
      }
    };

    AdobeLaunch.install(Vue);

    const scriptElement = document.head.querySelector(
      'script[src="//assets.adobedtm.com/95c3e405673d/81c80ecf6aaf/launch-8bd807155300-development.min.js"]'
    );
    expect(scriptElement).toBeTruthy();

    expect(scriptElement.async).toBe(true);
    expect(scriptElement.defer).toBe(true);

    expect(Vue.$log.info).toHaveBeenCalledWith("AdobeLaunch inyectada", "Test");
  });

  test("debería inyectar adobbe launch development para ambiente desa", () => {
    delete window.location;
    window.location = { hostname: "desa2-qa.bbva.com.ar" };

    const Vue = {
      $log: {
        info: jest.fn()
      }
    };

    AdobeLaunch.install(Vue);

    const scriptElement = document.head.querySelector(
      'script[src="//assets.adobedtm.com/95c3e405673d/81c80ecf6aaf/launch-8bd807155300-development.min.js"]'
    );
    expect(scriptElement).toBeTruthy();

    expect(scriptElement.async).toBe(true);
    expect(scriptElement.defer).toBe(true);

    expect(Vue.$log.info).toHaveBeenCalledWith(
      "AdobeLaunch inyectada",
      "Desarrollo"
    );
  });

  test("debería inyectar adobbe launch development para ambiente desa bbvafrances.com.ar", () => {
    delete window.location;
    window.location = { hostname: "desa2-qa.bbvafrances.com.ar" };

    const Vue = {
      $log: {
        info: jest.fn()
      }
    };

    AdobeLaunch.install(Vue);

    const scriptElement = document.head.querySelector(
      'script[src="//assets.adobedtm.com/95c3e405673d/81c80ecf6aaf/launch-8bd807155300-development.min.js"]'
    );
    expect(scriptElement).toBeTruthy();

    expect(scriptElement.async).toBe(true);
    expect(scriptElement.defer).toBe(true);

    expect(Vue.$log.info).toHaveBeenCalledWith(
      "AdobeLaunch inyectada",
      "Desarrollo"
    );
  });

  test("debería inyectar adobe launch development para entorno local", () => {
    delete window.location;
    window.location = { hostname: "localhost" };

    const Vue = {
      $log: {
        info: jest.fn()
      }
    };

    AdobeLaunch.install(Vue);

    const scriptElement = document.head.querySelector(
      'script[src="//assets.adobedtm.com/95c3e405673d/81c80ecf6aaf/launch-8bd807155300-development.min.js"]'
    );
    expect(scriptElement).toBeTruthy();

    expect(scriptElement.async).toBe(true);
    expect(scriptElement.defer).toBe(true);

    expect(Vue.$log.info).toHaveBeenCalledWith(
      "AdobeLaunch inyectada",
      "Desarrollo"
    );
  });
});
